(function (prototype) {
    if (typeof prototype.requestSubmit == "function")
        return;
    prototype.requestSubmit = function (submitter) {
        if (submitter) {
            validateSubmitter(submitter, this);
            submitter.click();
        }
        else {
            submitter = document.createElement("input");
            submitter.type = "submit";
            submitter.hidden = true;
            this.appendChild(submitter);
            submitter.click();
            this.removeChild(submitter);
        }
    };
    function validateSubmitter(submitter, form) {
        submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'", "typeError");
        submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button", "typeError");
        submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
    }
    function raise(errorConstructor, message, name) {
        throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name);
    }
})(HTMLFormElement.prototype);
const isRecaptchaEnabled = true;
const initRecaptcha = () => {
    if (isRecaptchaEnabled) {
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = `https://www.google.com/recaptcha/api.js?render=explicit&#038;hl=it-IT`;
        document.head.appendChild(script);
        contactForms && contactForms.length > 0 && contactForms.forEach((form, i) => {
            const recaptchaContainer = form.querySelector(".g-recaptcha");
            if (recaptchaContainer) {
                form.querySelector(".g-recaptcha").setAttribute("g-recaptcha-index", i.toString());
                return true;
            }
        });
    }
    return false;
};
const submitAfterCaptcha = (token) => {
    const formToSubmit = document.querySelector(`form[data-active-form='true']`);
    const recaptchaTextarea = formToSubmit.querySelector(".g-recaptcha-response");
    recaptchaTextarea.value = token;
    formToSubmit.requestSubmit();
};
